<template>
  <v-card elevation="0" color="transparent">
    <v-row class="ma-3" :class="{'dark-blue lighten-5': plansUserFormFlag}">
      <v-col :cols="!plansUserFormFlag ? 6 : 12">
        <h3>
          Current plan
          <v-btn small color="primary" icon @click="plansUserFormFlag = !plansUserFormFlag">
            <v-icon small>mdi-pencil</v-icon>
          </v-btn>
        </h3>

        <v-simple-table class="mb-5" v-if="!plansUserFormFlag">
          <tbody @click="plansUserFormFlag = !plansUserFormFlag">
          <tr>
            <td>Current plan</td>
            <td>{{userData.plan.name}}</td>
          </tr>
          <tr>
            <td>Max profiles</td>
            <td>{{userData.plan.maxProfiles}}</td>
          </tr>
          <tr>
            <td>Quota</td>
            <td>
              {{getQuota}} % ({{quota.staffCount}} at Staff, {{quota.scoutingCount}} at Scouting)
            </td>
          </tr>
          <tr v-if="userData.plan.requestedChangePlan">
            <td>Requested new plan</td>
            <td>{{userData.plan.requestedChangePlan.name}}</td>
          </tr>
          </tbody>
        </v-simple-table>

        <template v-else>
          <iceverg-plans :current-plan="currentPlan"  @cancel="plansUserFormFlag = false"></iceverg-plans>
        </template>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
  import IcevergPlans from "./../Widgets/icevergPlans";

  import api from '@/api/index'

  export default {
    name: "editPlans",
    components: {IcevergPlans},
    props: ['userData'],
    data: () => ({
      plansUserFormFlag: false,
      quota: {}
    }),
    methods: {
      loadCompanyQuota() {
        const clientId = this.userData.clientId
        api.clients.getCompanyQuota({clientId}).then((response) => {
          this.quota = response.data.data
          console.log(this.quota)
        })
      }
    },
    computed: {
      getQuota(){
        return Math.round((this.quota.staffCount + this.quota.scoutingCount) / this.quota.maxProfiles * 100);
      },
      currentPlan(){
        return {
          ...this.userData.plan,
          staffCount: this.quota.staffCount,
          scoutingCount: this.quota.scoutingCount,
        }
      }
    },
    mounted() {
      this.loadCompanyQuota()
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Sections/editPlans.vue